import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function converUTCDateToLocalDate({
  utcString = '',
  customDateOptions = {},
  customTimeOptions = {},
  locale = 'en-US',
}: {
  utcString: string;
  customDateOptions?: Intl.DateTimeFormatOptions;
  customTimeOptions?: Intl.DateTimeFormatOptions;
  locale?: string;
}) {
  const date = new Date(utcString);

  // Merge default and custom time options
  const timeOptions: Intl.DateTimeFormatOptions = {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
    ...customTimeOptions,
  };

  // Merge default and custom date options
  const dateOptions: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    ...customDateOptions,
  };
  const datePart = new Intl.DateTimeFormat(locale, dateOptions).format(date);
  const timePart = new Intl.DateTimeFormat(locale, timeOptions).format(date);
  return { dateString: datePart, timeString: timePart };
}
